import TaskBox from "components/TaskBox";
import moment from "moment";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import { ITask } from "dto/ITask";
import NotFoundScreen from "components/NotFoundScreen";
import { useContext } from "react";
import ModalsManagerContext from "contexts/ModalsManager";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

const ActionBox: FC<Props> = ({
  date,
  items,
  handleChangeStatus,
  handleDelete,
  handleChangeFlag,
  handleUpdateTask,
  handleAddTag,
  handleRemoveTag,
  refetch,
  isDesk,
}) => {
  const { t } = useTranslation();

  const months = [
    t("calendar.months.january"),
    t("calendar.months.february"),
    t("calendar.months.march"),
    t("calendar.months.april"),
    t("calendar.months.may"),
    t("calendar.months.june"),
    t("calendar.months.july"),
    t("calendar.months.august"),
    t("calendar.months.september"),
    t("calendar.months.october"),
    t("calendar.months.november"),
    t("calendar.months.december"),
  ];

  const days = [
    t("calendar.days.monday"),
    t("calendar.days.tuesday"),
    t("calendar.days.wednesday"),
    t("calendar.days.thursday"),
    t("calendar.days.friday"),
    t("calendar.days.saturday"),
    t("calendar.days.sunday"),
  ];

  if (!date) {
    return <></>;
  }
  const { modals, setModals } = useContext(ModalsManagerContext);
  const dateToCompare = moment(date);
  const today = moment(new Date());

  const isActualDay = dateToCompare.startOf("day").isSame(today.startOf("day"));

  return (
    <div className={classNames(styles.box, isDesk ? styles.desk : undefined)}>
      <div className={styles.date}>
        <div className={`${isActualDay ? styles.actual : styles.day}`}>
          {moment(date).format("DD")}
        </div>
        <div className={styles.month}>
          <div className={styles.weekDay}>{days[moment(date).weekday()]}</div>
          <div className={styles.weekMonth}>
            {months[moment(date).month()]} {moment(date).year()}
          </div>
        </div>
        {/* {moment(date).format('DD')}
        <div className={styles.day}>{months[moment(date).month()]}</div>
        {moment(date).format('YYYY')} */}
      </div>
      {!items.length && (
        <div className={styles.empty}>
          <NotFoundScreen
            title={isDesk ? t("emptyStates.emptyDesk") : t("emptyStates.notFound")}
            text={
              isDesk
                ? t("emptyStates.deskDescription")
                : t("emptyStates.noResultsSuffix")
            }
            buttonName={isDesk ? t("actions.addEvent") : null}
            onClick={() => setModals({ ...modals, createTask: true })}
          />
        </div>
      )}
      {!!items.length && (
        <div className={`${styles.wrapper} ${styles.allDay}`}>
          <div className={styles.hours}>{t("calendar.allDayShort")}</div>
          <div className={styles.card}>
            {items
              .filter((p: ITask) => p.AllDay)
              .map((item: ITask) => (
                <TaskBox
                  key={item.Id}
                  refetch={refetch}
                  handleAddTag={handleAddTag}
                  handleRemoveTag={handleRemoveTag}
                  handleUpdateTask={handleUpdateTask}
                  handleChangeFlag={handleChangeFlag}
                  handleDelete={handleDelete}
                  handleChangeStatus={handleChangeStatus}
                  task={item}
                />
              ))}
          </div>
        </div>
      )}
      {!!items.length && (
        <>
          {items
            .filter((p: ITask) => !p.AllDay)
            .map((item: ITask) => {
              return (
                <div key={item.Id} className={styles.wrapper}>
                  <div className={styles.hours}>
                    {moment(item.FromDate).format("HH:mm")}
                    {item.ToDate && (
                      <> - {moment(item.ToDate).format("HH:mm")}</>
                    )}
                  </div>
                  <div className={styles.card}>
                    <TaskBox
                      refetch={refetch}
                      handleAddTag={handleAddTag}
                      handleRemoveTag={handleRemoveTag}
                      handleUpdateTask={handleUpdateTask}
                      handleChangeFlag={handleChangeFlag}
                      handleDelete={handleDelete}
                      handleChangeStatus={handleChangeStatus}
                      task={item}
                    />
                  </div>
                </div>
              );
            })}
        </>
      )}
    </div>
  );
};

export default ActionBox;
